import { buildCoreContext, } from '../core/context/headless-core-context.js';
/**
 * Creates a `Context` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Context` controller properties.
 *
 * @returns A `Context` controller instance.
 *
 * @object Controllers
 * @category Context
 */
export function buildContext(engine, props) {
    return buildCoreContext(engine, props);
}
